// extracted by mini-css-extract-plugin
module.exports = {"s1r0t4go":"s1r0t4go"};